import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import gCard from "@/components/g-card/g-card.vue";
import gSteps from "@/components/g-steps/g-steps.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import { helpers, requiredIf, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import OrcamentoSequenciaController from "@/shared/controllers/orcamentoSequencia/orcamentoSequenciaController";
import ProdutoController from "@/shared/controllers/produto/produtoController";

import { defineComponent } from "vue";

const name = "CaracProdutoRepeticao";
export default defineComponent ({
  name,

  components: {
    "g-card": gCard,
    "g-form": gForm,
    "g-button": gButton,
    "g-steps": gSteps,
    "g-date-input": gDateInput,
  },
  props: {},

  mounted() {
    OrcamentoController.VerificaSeOrcamentoTemQuantidade(this.$route.params.id).requisicao
    .then((response) => {
      if(response.data.data == false){
        this.$toast.add({severity:'error', detail:'Erro ao Salvar Quantidade. Por favor tente novamente.', life: 5000})
        this.$router.push(`/produto-repeticao/${this.$route.params.id}/info-basicas-repeticao`)
      }
    })
    this.ImagemEmpresa()
    this.getComponentesByProdutoIdSelecionado();
    this.getLoteSequencia();
    this.getReorcamento();
    this.getCaracteristicasProduto();
    this.getOrcamentoSequencia();

    this.TiposOrcamentoArray = OrcamentoSequenciaController.GetTiposOrcamento().TiposOrcamentoArray;
    this.ProdutoArray = ProdutoController.GetProdutoByOrcamentoClienteEmpresa(this.$route.params.id).ProdutoArray
  },

  updated() {},

  data() {
    return {
      popupCancelaOrc: false,
      imagemEmpresa:'',
      Colunas: [
        {field: 'tipo', header: 'Tipo'},
        {field: 'produto', header: 'Produto'},
      ],
      InformacaoProdutosSequencia: [],
      produtoId: null,
      ProdutoArray: [],
      TipoOrcamentoEnum: 1,
      TiposOrcamentoArray: [],
      submit: false,
      comprimentoPalete: '',
      larguraPalete: '',
      alturaPalete: '',
      melhorAproveitamento: false,
      observacaoPalete: '',
      copiaOrcamentoQuantidade:false,
      AbrirPopupPadrao: false,
      reorcamento: false,
      critica1: false,
      critica2: false,
      critica3: false,
      critica4: false,
      critica5: false,
      informacao: [],
      informacaoCaixa: false,
      informacaoFilmeEncolhivel: false,
      informacaoOutras: false,
      informacaoPalete: false,
      loteDescricao: "",
      temLote: false,
      loteInfoFalse: false,
      loteInfoText: "",
      observacao: "",
      optionscriticas1: false,
      optionscriticas2: false,
      optionscriticas3: false,
      optionscriticas4: false,
      optionscriticas5: false,
      optionscriticas6: false,
      optionsespecificaCaixa: false,
      optionsespecificaFilme: false,
      optionsespecificaOutros: false,
      optionsespecificaPaleta: false,
      optionsgeraisFSC: false,
      optionsgeraisLeg: false,
      orcamentoVariacao: [],
      outrosEmbalagem: "",
      popup: false,
      sequenciaDescricao: "",
      sequenciaValue: false,
      sugestaoSequencia: [
        {
          texto: "Padrão",
          valor: 0,
        },
        {
          texto: "Especifico",
          valor: 1,
        },
      ],
      sugestaoLotes: [
        {
          nome: "Lote 1",
          valor: 0,
        },
        {
          nome: "Lote 2",
          valor: 1,
        },
        {
          nome: "Lote 3",
          valor: 2,
        },
      ],

      //Novo Orcamento
      OrcamentoId: null,
      papelSeda: false,
      medidaPapelSeda: '',
      medidaPapelSeda2: ''
    };
  },

  setup(){
    return{
      v$: useVuelidate()
    }
  },

  validations(){
    let sequenciaDescricaoValidation;
    let temSequencia = this.sequenciaValue;

    if (temSequencia) {
      sequenciaDescricaoValidation = {
        required: helpers.withMessage(
          "O campo Descrição de Sequência é obrigatório",
          required
        ),
      };
    } else {
      sequenciaDescricaoValidation = {};
    }

      let validaCamposPalete = this.informacaoPalete && !this.melhorAproveitamento
      let alturaPaleteValidation = {require: helpers.withMessage('o campo altura para Palete é obrigatório', requiredIf(validaCamposPalete && this.AbrirPopupPadrao))};
      let larguraPaleteValidation = {require: helpers.withMessage('o campo largura para Palete é obrigatório', requiredIf(validaCamposPalete &&this.AbrirPopupPadrao))};
      let comprimentoPaleteValidation = {require: helpers.withMessage('o campo comprimento para Palete é obrigatório', requiredIf(validaCamposPalete && this.AbrirPopupPadrao))};

      return {
        loteDescricao: {require: helpers.withMessage(`Preencha o campo de Lote: ${this.loteInfoText}`, requiredIf(this.temLote && this.AbrirPopupPadrao))},
        sequenciaDescricao:sequenciaDescricaoValidation,
        alturaPalete: alturaPaleteValidation,
        larguraPalete: larguraPaleteValidation,
        comprimentoPalete: comprimentoPaleteValidation,
      }
  },

  methods: {
    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-repeticao-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },

    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },

    getOrcamentoSequencia(){
      OrcamentoSequenciaController.GetOrcamentoSequenciaByOrcamentoId(this.$route.params.id).requisicao
      .then(res => {
        this.InformacaoProdutosSequencia = res.data.data.informacaoProdutosSequencia
        
      });
    },

    excluir(data) {
      let dataEmString = JSON.stringify(data)
      this.InformacaoProdutosSequencia = this.InformacaoProdutosSequencia.filter(e => JSON.stringify(e) != dataEmString)
    },

    adicionarProdutoAoGrid(){
      if(this.TipoOrcamentoEnum == null && this.produtoId == null)
      {
        this.$toast.add({ severity: 'error', summary: 'Selecione um Tipo e um Produto', detail: 'Tipo e Produto Obrigatórios', life: 4000 });
        return
      }
      if(this.TipoOrcamentoEnum == null && this.produtoId != null)
      {
        this.$toast.add({ severity: 'error', summary: 'Selecione um Tipo e um Produto Também', detail: 'Tipo e Produto Obrigatórios', life: 4000 });
        return
      }
      if((this.TipoOrcamentoEnum == 1 && this.produtoId == null) || (this.TipoOrcamentoEnum == 2 && this.produtoId == null) )
      {
        this.$toast.add({ severity: 'error', summary: 'Produto Obrigatório', detail: 'Selecione um produto', life: 4000 });
        return
      }

      if(this.TipoOrcamentoEnum != 0)
      {
        let Produto = this.ProdutoArray.find((Element) => Element.produtoId == this.produtoId)
        let TipoText = this.TiposOrcamentoArray.find((Element) => Element.enum == this.TipoOrcamentoEnum)

        let variavel =
          {"produtoId": this.produtoId, "tipoEnum": this.TipoOrcamentoEnum, "tipo":TipoText.text, "produto": Produto.nomeProduto }
          this.InformacaoProdutosSequencia.push(variavel)

        return
      }

      if(this.TipoOrcamentoEnum == 0)
      {
        let TipoText = this.TiposOrcamentoArray.find((Element) => Element.enum == this.TipoOrcamentoEnum)
        let variavel =
          {"produtoId":null, "tipoEnum": this.TipoOrcamentoEnum, "tipo": TipoText.text, "produto": null }


          this.InformacaoProdutosSequencia.push(variavel)

        return
      }


    },

    voltarstep4() {
      this.$router.push(
        `/produto-repeticao/${this.$route.params.id}/componentes-produto-repeticao`
      );
    },

    removerNaoDigitos(textoOriginal){
      return textoOriginal.replaceAll(/\D/gm, '');
    },

    aplicarCentimetro(valor){
      if(!this[valor]) return;
      this[valor] += ' cm'
    },

     insertOrcamentoVariacao() {
       this.axios({
         method: 'post',
         url: process.env.VUE_APP_WEB_API + `Orcamento/InsertOrReplaceOrcaProdRepet/${this.$route.params.id}`,
         data:{
        }
      })
        .then((response) => {
          this.OrcamentoId = response.data.data;
          this.$router.push(
            `/produto-repeticao/${this.OrcamentoId}/Informacao-Cliente-Repeticao`
          );
        })
        .catch(() => {});
    },

    paginafinalizada() {
      this.submit = true;
      this.$isLoading(true)

      if (this.sequenciaValue) {
        if(this.InformacaoProdutosSequencia.length < 2 && this.AbrirPopupPadrao) {
          this.$toast.add({ severity: 'error', summary: 'Selecione no mínimo 2 produtos da Sequência', detail: 'Selecione no mínimo 2 produtos da Sequência', life: 4000 });
          return
        }
      }

      if(this.v$.$invalid) {
        this.v$.$silentErrors.forEach(erro => {
          this.$toast.add({
            severity: 'error',
            summary: 'Campo não preenchido',
            detail: erro.$message,
            life: 3000
          });
        });
        
        return;
      }
      this.$refs.botaoContinuar.isBusy()


      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Orcamento/postCaracProdRepeticao/${this.$route.params.id}`,
        data: {
          OrcamentoId:this.$route.params.id,
          FSC:this.optionsgeraisFSC,
          Legislacao:this.optionsgeraisLeg,
          EmbalagemEspecificaFilmeEncolhivel: this.informacaoFilmeEncolhivel,
          EmbalagemEspecificaCaixaColetiva:this.informacaoCaixa,
          EmbalagemEspecificaPalete:this.informacaoPalete,
          EmbalagemOutros:this.informacaoOutras,
          OutrosEmbalagem: this.outrosEmbalagem,
          Lote:this.loteDescricao != "" ? this.loteDescricao : null,
          DescricaoSequencia: this.sequenciaDescricao != '' ? this.sequenciaDescricao : null,
          AlturaPalete:  this.alturaPalete != '' ? this.removerNaoDigitos(this.alturaPalete) : null,
          LarguraPalete: this.larguraPalete != '' ? this.removerNaoDigitos(this.larguraPalete) : null,
          ComprimentoPalete:  this.comprimentoPalete != '' ? this.removerNaoDigitos(this.comprimentoPalete) : null,
          MelhorAproveitamento: this.melhorAproveitamento,
          ObservacaoPalete: this.observacaoPalete,
          PapelSeda: this.papelSeda,
          MedidaPapelSeda: this.medidaPapelSeda,
          MedidaPapelSeda2: this.medidaPapelSeda2,
          ObservacoesGerais: this.observacao
        }
      })
      .then(() => {
      }).finally(()=> {
        this.$isLoading(false)
        this.$refs.botaoContinuar.isBusy
        this.SalvarOrcamentoSequencia()
      })
    },
    EnviaOrcamentoCRM(){
      this.axios({
        method: "post",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/EnviarOrcamentoCRM/${this.$route.params.id}`,
      })
      .then((response) => {
        if (response.data && response.data.code < 0) {
          console.error('Erro ao enviar orçamento para CRM:', response.data.message);
          this.$toast.add({ severity: 'warn', summary: 'Integração CRM', detail: response.data.message || 'Erro ao integrar com CRM', life: 8000 });
        }
      })
      .catch((err) => {
        console.error('Erro ao enviar orçamento para CRM:', err);
        this.$toast.add({ severity: 'error', summary: 'Integração CRM', detail: 'Falha ao enviar orçamento para o CRM: ' + (err?.response?.data?.message || err.message), life: 8000 });
      });
    },
    SalvarOrcamentoSequencia(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'OrcamentoSequencia/PostOrcamentoSequencia',
        data: {
          InformacaoProdutosSequencia: this.InformacaoProdutosSequencia,
          orcamentoId: this.$route.params.id,
        }
      })
        .then(() => {
          setTimeout(() => {
            this.EnviaOrcamentoCRM();
          }, 1000)
          this.$router.push(
            `/orcamento-final-repeticao/${this.$route.params.id}`
          );

        })
        .catch(() => {
        });
    },

    fechapopup() {
      this.popup = false;
      this.insertOrcamentoVariacao();
    },

    camponumero ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },

    getComponentesByProdutoIdSelecionado() {
      this.$isLoading(true)
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Componente/GetComponentesByProdutoIdOrcamentoId/${this.$route.params.id}`,
      })
        .then((Response) => {
          Response.data.data.forEach((obj) => {
            this.informacao.push(obj);
          });
          this.informacaoCaixa = Response.data.data[0].embalagemEspecificaCaixaColetiva;
          this.informacaoFilmeEncolhivel = Response.data.data[0].embalagemEspecificaFilmeEncolhivel;
          this.informacaoPalete = Response.data.data[0].embalagemEspecificaPalete;
          this.informacaoOutras = Response.data.data[0].outros;
          this.critica1 = Response.data.data[0].critica1;
          this.critica2 = Response.data.data[0].critica2;
          this.critica3 = Response.data.data[0].critica3;
          this.critica4 = Response.data.data[0].critica4;
          this.critica5 = Response.data.data[0].critica5;
          this.observacao = Response.data.data[0].observacoesGerais;
          // this.teste(Response.data.data);

          this.informacao.forEach((r) => {
            r.ColunaMedidas = `${r.numeroAltura} x ${r.numeroComprimento} x ${r.numeroLargura}`;
          });
          this.key++;
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },


    getLoteSequencia() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetLoteSequenciaByOrcamentoId/${this.$route.params.id}`,
      })
        .then((response) => {
          this.loteInfoText = response.data.data.informacaoLoteText;
          this.sequenciaValue = response.data.data.sequencia;

          if (this.loteInfoText === "Não") {
            this.loteInfoFalse = false;
            this.temLote = false
          } else {
            this.loteInfoFalse = true;
            this.sequenciaValue = false;
            this.temLote = true
          }
        })
        .catch(() => {});
    },


    getReorcamento() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetInfosBasicasProdutoNovo/${this.$route.params.id}`,
      })
        .then((Response) => {
          this.reorcamento = Response.data.data.reorcamento
          this.copiaOrcamentoQuantidade = Response.data.data.copiaOrcamentoQuantidade
          if( this.copiaOrcamentoQuantidade==false && this.reorcamento==false )
          {
            this.AbrirPopupPadrao = true
          }

          
          if( this.copiaOrcamentoQuantidade==null && this.reorcamento==null )
          {
            this.AbrirPopupPadrao = true
          }
        })
        .catch(() => {});
    },


    getCaracteristicasProduto(){
      OrcamentoController.GetCaracteristicasRepeticao(this.$route.params.id).requisicao
      .then(res => {
        this.optionsgeraisFSC = res.data.data.fsc;
        this.tipoSelecionado = res.data.data.tipo;
        this.optionsgeraisLeg = res.data.data.legislacao;
        //this.informacaoOutras = res.data.data.embalagemOutros;
        this.outrosDesc = res.data.data.descricaoOutrasEmbalagens;
        this.observacao = res.data.data.observacao;
        this.descricaoespec = res.data.data.descricaoOutrasEmbalagensEspecificas;
        //this.informacaoFilmeEncolhivel = res.data.data.embalagemEspecificaFilmeEncolhivel;
        //this.informacaoCaixa = res.data.data.embalagemEspecificaCaixaColetiva;
        //this.informacaoPalete = res.data.data.embalagemEspecificaPalete;
        this.loteDescricao = res.data.data.lote;
        this.sequenciaDescricao =  res.data.data.descricaoSequencia;
        this.papelSeda = res.data.data.papelSeda;
        this.medidaPapelSeda = res.data.data.medidaPapelSeda;
        this.medidaPapelSeda2 = res.data.data.medidaPapelSeda2
      })
    }
  },

  computed: {},
  watch: {
    melhorAproveitamento(novoValor){
      if(novoValor){
        this.alturaPalete = ''
        this.comprimentoPalete = ''
      }
    },
  }
});
